import React from "react";
import PropTypes from "prop-types";
import UpgradeForm from "components/payments/UpgradeForm";
import UpgradePrice from "components/payments/UpgradePrice";
import { fetchUpgradePrice } from "components/payments/hooks";

export default function TeacherUpgradeModalForm(props) {
  const {
    defaultErrorMessage,
    lastPaidWithStripe,
    planCode,
    planCost,
    planId,
    paypalEnvironment,
    upgradePricePath
  } = props;

  // I'm pulling these off separately because they are only used in test.
  // If they're undefined, the real elements will be used, but if components
  // are passed in, we can render a slightly different version of this component
  // to use in Capybara tests without actually talking to either Stripe or Paypal.
  const { PaypalButton, StripePaymentElement } = props;

  const upgradePrice = fetchUpgradePrice(props.upgradePrice, upgradePricePath);

  return (
    <div>
      <div className="upgrade-summary">
        <p className="user-subscribe-sell__section tw-text-base tw-leading-7">
          <strong>
            $<UpgradePrice upgradePrice={upgradePrice} /> due today,{" "}
          </strong>
          a prorated discount reflecting what you have already paid this year
          for your LitCharts A⁺ annual subscription.
        </p>
        <p className="user-subscribe-sell__section tw-text-base tw-leading-7">
          Renewals of your upgraded LitCharts A⁺ Teacher annual subscription
          will be charged at the normal rate of {planCost} USD.
        </p>
      </div>
      <UpgradeForm
        defaultErrorMessage={defaultErrorMessage}
        FormButtons={FormButtons}
        lastPaidWithStripe={lastPaidWithStripe}
        PaypalButton={PaypalButton}
        paypalEnvironment={paypalEnvironment}
        planCode={planCode}
        planId={planId}
        StripePaymentElement={StripePaymentElement}
        upgradePrice={upgradePrice}
      />
    </div>
  );
}

TeacherUpgradeModalForm.propTypes = {
  PaypalButton: PropTypes.element,
  StripePaymentElement: PropTypes.element,
  lastPaidWithStripe: PropTypes.bool.isRequired,
  paypalEnvironment: PropTypes.string.isRequired,
  planCode: PropTypes.string.isRequired,
  planCost: PropTypes.string.isRequired,
  planId: PropTypes.string.isRequired,
  upgradePrice: PropTypes.shape({
    errorMessage: PropTypes.string,
    price: PropTypes.string,
    prorationDate: PropTypes.string
  }).isRequired,
  upgradePricePath: PropTypes.string.isRequired
};

const FormButtons = ({ disabled, processing }) => (
  <div className="user-subscribe-sell__upgrade-subscription tw-flex tw-justify-center !tw-mt-4">
    <button
      className="btn btn-primary btn-lg form-button form-submit js-upgrade-button"
      disabled={disabled || processing}
      type="submit"
    >
      {processing ? (
        <span>
          <i className="fa fa-cog fa-spin fa-fw" />
          Upgrading
        </span>
      ) : (
        "Upgrade to Annual"
      )}
    </button>
  </div>
);
